import { render, staticRenderFns } from "./LocationPerformance.vue?vue&type=template&id=a05c2af6&scoped=true&"
import script from "./LocationPerformance.vue?vue&type=script&lang=ts&"
export * from "./LocationPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./LocationPerformance.vue?vue&type=style&index=0&id=a05c2af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c2af6",
  null
  
)

export default component.exports